import React from 'react';
import { useI18n } from '../../context/I18nContext';
import { useGetMyTransactions } from '../paymentApis';
import ScrollablePage from '../../components/ui/ScrollablePage';
import { TransactionList } from '../components/TransactionList';

const AllRecentReceiptsView = () => {
  const { I18n } = useI18n();

  const getMyTransactions = useGetMyTransactions();

  const transactions = getMyTransactions.data?.data?.getMyTransactions ?? [];

  return (
    <ScrollablePage
      summary={{
        title: I18n.t('payment.receipts.summaryTitle'),
        description: I18n.t('payment.receipts.summaryDescription'),
        icon: 'doc',
      }}
    >
      <TransactionList transactions={transactions} />
    </ScrollablePage>
  );
};

export default AllRecentReceiptsView;
